/* Import bootstrap */
import 'bootstrap';
import $ from 'jquery';
import TomSelect from 'tom-select';

window.jQuery = window.$ = $;

/* JQuery */
import 'jquery-ui/ui/widgets/datepicker.js';

/* EasyMDE */
import EasyMDE from 'easymde';
window.EasyMDE = EasyMDE;

/* SENTRY reporting*/
import * as Sentry from "@sentry/browser";

// CUREDI Style
import '../css/common.css';


Sentry.init({
    dsn: import.meta.env.SENTRY_LARAVEL_DSN,
    integrations: [
        Sentry.feedbackIntegration({
            colorScheme: "system",
        }),
    ],
});

// Configure the datepicker
var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

$('.datepicker').datepicker({
    dateFormat: "yy-mm-dd",
    maxDate: today,
    changeMonth: true,
    changeYear: true,
    yearRange: "1900:c"
});

['#startDate', '#endDate', '#startUpdate', '#endUpdate'].forEach(id => {
    if ($(id).length) {
        $(id).datepicker({
            dateFormat: "yy-mm-dd",
            maxDate: today,
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:c"
        });
    }
});

// show book details only when necessary
$('#book_details').hide();

$('#type_id').on('change', function () {
    if (this.value === "4") $("#book_details").show();
    else $("#book_details").hide();
}).trigger("change");

$(function () {
    $(".collapse.show").each(function () {
        $(this).prev(".card-header").find(".fa-solid").addClass("fa-minus").removeClass("fa-plus");
    });

    $(".collapse").on('show.bs.collapse', function () {
        $(this).prev(".card-header").find(".fa-solid").removeClass("fa-plus").addClass("fa-minus");
    }).on('hide.bs.collapse', function () {
        $(this).prev(".card-header").find(".fa-solid").removeClass("fa-minus").addClass("fa-plus");
    });
});

// Keyword search

// 1. Basic usage
document.querySelectorAll('.select2').forEach(el => {
    if (el) new TomSelect(el);
});

// 2. Tagging select
const select2Tags = document.querySelector('#select2-tags');
if (select2Tags) {
    new TomSelect(select2Tags, {
        create: true,
        delimiter: ';',
        persist: false,
        closeAfterSelect: false
    });
}

// 3. Live search via AJAX
document.querySelectorAll('.livesearch').forEach(el => {
    if (el) {
        new TomSelect(el, {
            valueField: 'id',
            labelField: 'text',
            searchField: 'text',
            placeholder: 'Select keyword',
            load: function (query, callback) {
                if (!query.length) return callback();
                fetch(`/keyword-autocomplete?q=${encodeURIComponent(query)}`)
                    .then(response => response.json())
                    .then(data => {
                        const results = data.map(item => ({
                            id: item.id,
                            text: item.keyword
                        }));
                        callback(results);
                    }).catch(() => callback());
            }
        });
    }
});

jQuery(document).ready(function ($) {
    // Remove empty fields from GET forms
    $("form").submit(function () {
        $(this).find(":input").filter(function () {
            return !this.value;
        }).attr("disabled", "disabled");
        return true;
    });
    $("form").find(":input").prop("disabled", false);
});
